import api from '../api/instance';
 
import { Page } from '../models/page';
import { Role } from '../models/role.model';
import { useQuery } from 'react-query';

const nameSpace = '/roles';

const getRoles = () => {
  return api
    .get(nameSpace)
    .then((res) => new Page<Role>().deserialize(res, Role))
    .catch((e) => Promise.reject(e));
};

export const useFetchProjectRoles = (enabled = true) =>
  useQuery(
    'project-roles',
    async () => {
      const response = await getRoles();
      response.content = response.content.filter(
        (role) => !role.isSuperAdmin && !role.isAgent,
      );
      return response;
    },
    { enabled },
  );

const RoleMappingService = {
  getRoles,
};

export default RoleMappingService;
